import React, { useState, useEffect } from "react";
import { slice } from "lodash";
import { useParams } from 'react-router-dom';
//import {Link} from 'react-router-dom';
import InnerBanner from '../components/InnerBanner'; 
import Accordion from 'react-bootstrap/Accordion';
//import HotDestinations from '../home/HotDestinations';
import Helmet from "react-helmet";

export default function PackageDetailCraftIndia() {
  const params = useParams();
  
    const [apilink] = useState(
        "/databases/packagesCraftIndia.json"
      );
      //const [apilink, setApilink] = useState([])
      const [post, setPost] = useState([]);
   //const [ setIsCompleted] = useState(false);
      const [index] = useState();
      let initialPosts = slice(post, 0, index);
      const getData = (apilink) => {
        fetch(apilink)
          .then((res) => res.json())
          .then((json) => setPost(json))
          .catch((e) => console.log(e));
      };

      useEffect(() => {
        getData(apilink);
      }, [apilink]);

       initialPosts = initialPosts.filter(item => item.destinationname === params.loc);
  return (
    <>
      {initialPosts.map((item, i) => {
          
          
          return ( 
            <React.Fragment key={item.id}>
            
         {

          
        item.packages.map((itemm, j) => {
          
          if(itemm.pack_url === params.pack_url){
   
          return ( 
            <>
             <Helmet>
         
               <title>{itemm.det_page_data[0].titledet}</title>
     
             </Helmet>

    <InnerBanner imgPath={itemm.det_page_data[0].itneraryBanner} innerTitle={itemm.packname} />
     
     <section className="allPackages">
        <div className="container">
            <div className="row">
           
           
             
            <div className="col-md-8"> 
                <div className="packDetailpage">
                  <h1 className="heading">{itemm.det_page_data[0].heading1}</h1>
                  <p className="hdDetail" dangerouslySetInnerHTML={{ __html: itemm.det_page_data[0].content }}></p>

                  <div className="whyChoose" dangerouslySetInnerHTML={{ __html: itemm.det_page_data[0].whychoose }}></div>
                  
                  <Accordion defaultActiveKey="1">
                {    
                  itemm.det_page_data[0].accordion.map((acc, a) => 
                    
                    (
                      
                      <Accordion.Item eventKey={acc.id}>
                          <Accordion.Header>{acc.q1}</Accordion.Header>
                          <Accordion.Body>
                             <p dangerouslySetInnerHTML={{ __html: acc.a1 }}></p>
                          </Accordion.Body>
                     </Accordion.Item>
                     ))
                     
                    }
    
    </Accordion>

                    
                </div>
                
            </div>
            
            
 
            <div className="col-md-4">
                
                {/* <HotDestinations cls="col-md-12"/> */}

                <div className="inclusions">
                  <h2>Inclusions:</h2>
                    <ul dangerouslySetInnerHTML={{ __html: itemm.det_page_data[0].inclusions }}></ul>
                </div> 
                <div className="exclusions">
                  <h2>Exclusions:</h2>
                    <ul dangerouslySetInnerHTML={{ __html: itemm.det_page_data[0].exclusions }}></ul>
                </div>
              </div>
            </div>
        </div>
     </section>
     </>
);}
})
}
        </React.Fragment>
  );
})}

    </>
  )
}
